import React from 'react';
import SetCard from 'components/set/SetCard';
import { Content, BasicOption } from '../lib/FL';
import styles from './SetPage.module.scss';

type Props = {
  contents?: Content[];
  options?: BasicOption[];
};

const BasicPage: React.FC<Props> = ({ contents, options }) => (
  <main className={styles.basic}>
    <p className={styles.tax}>税抜価格表示となっております。別途消費税が掛かります。</p>
    {options?.map((option) => (
      <SetCard basicContents={contents} option={option} key={option.id} />
    ))}
  </main>
);

BasicPage.defaultProps = {
  contents: undefined,
  options: undefined,
};

export default BasicPage;
